export const REVIEW_ALREADY_SUBMITTED = 'REVIEW_ALREADY_SUBMITTED';

const ALREADY_REVIEWED_MESSAGE_PARTS = [
  'already submitted',
  'bereits bewertet',
  'existiert bereits eine bewertung',
];

const normalizeMessage = (message) => String(message || '').toLowerCase();

export const collectReviewErrorMessages = (error) => {
  const graphQLErrors = error?.graphQLErrors || error?.networkError?.result?.errors || [];
  const nestedErrors = Array.isArray(graphQLErrors) ? graphQLErrors : [];

  return [
    error?.message,
    ...nestedErrors.map((nestedError) => nestedError?.message),
  ].filter(Boolean);
};

export const isAlreadyReviewedError = (error) => {
  if (error?.code === REVIEW_ALREADY_SUBMITTED) {
    return true;
  }

  return collectReviewErrorMessages(error).some((message) => {
    const normalizedMessage = normalizeMessage(message);
    return ALREADY_REVIEWED_MESSAGE_PARTS.some((messagePart) => (
      normalizedMessage.includes(messagePart)
    ));
  });
};

export const createAlreadyReviewedError = (
  message = 'Du hast diese Buchung bereits bewertet.'
) => {
  const error = new Error(message);
  error.code = REVIEW_ALREADY_SUBMITTED;
  return error;
};

export const normalizeReviewError = (error) => (
  isAlreadyReviewedError(error) ? createAlreadyReviewedError(error?.message) : error
);
